/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum Entity {
    Paid,
    Quota,
    Ratio,
}
